<template>
  <div id="defaultModal" class="modal fade" tabindex="-1">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body">

          <div class="d-flex align-items-center p-3">
            <div class="centered-circle flex-shrink-0 bg-secondary text-primary h-10 w-10">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                   stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                   class="feather feather-code small-icon">
                <polyline points="16 18 22 12 16 6"></polyline>
                <polyline points="8 6 2 12 8 18"></polyline>
              </svg>
            </div>
            <div class="ms-3">
              <h3 class="fs-5 spacing-close">Default Custom Modal</h3>
            </div>
          </div>

          <!-- Content Here -->
          <div>

            <div>How to use this component</div>

            <ul>
              <li>Copy this component into a new component.</li>
              <li>Change the top level id and also update it in getElementById call in mounted.</li>
              <li>Update Content and the Handlers as needed!</li>
            </ul>

          </div>

        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary font-sm" style="min-width: 150px;" @click="onOkClick">Ok
          </button>
          <button type="button" class="btn btn-outline-primary font-sm" data-bs-dismiss="modal"
                  style="min-width: 150px;">Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>


export default {
  name: 'DefaultModal',
  props: {
    yesEvent: Function,
  },
  data() {
    return {
      model: streetmetrics.model,
      currentModal: null,
      modalElement: null,
      errorMessage: null,
    }
  },
  computed: {


  },
  mounted() {
    this.modalElement = document.getElementById('defaultModal')
    this.currentModal = new bootstrap.Modal(this.modalElement)

    this.modalElement.addEventListener('hidden.bs.modal', () => {
      this.$emit('noEvent')
    })

    this.currentModal.show()
  },
  beforeDestroy() {
    this.modalElement.removeEventListener('hidden.bs.modal')
  },
  methods: {
    onSaveClick() {
      this.errorMessage = null
    },

    noHandler(e) {
      // hide the modal
      this.currentModal.hide()
    },
    onOkClick() {
      // call the parent's "yesEvent"
      if (this.yesEvent) {
        this.yesEvent()
      }
      // hide the modal
      this.noHandler()
    }
  }
}
</script>

<style>

</style>
